import React, { useState, useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { useUserDetails } from "../../context/auth";
const Payroll = () => {
  const navigate = useNavigate();
  const {setexceldisplay,setexcelmonth,setexcelyear} = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);

  useEffect(() => {
    onSalaryStructureSubmit();
  }, []);

  const EarningListTable = {
    rows: [
      {
        id: 1,
        year: "2025",
        month: "January",
        category: "Category 1",
      },
      {
        id: 2,
        year: "2025",
        month: "February",
        category: "Category 1",
      },
    ],
  };

  const SalaryStructureListTable = {
    columns: [
      {
        field: "year",
        headerName: "Year",
        width: 300,

        sortable: true,
      },
      {
        field: "month",
        headerName: "Month",
        width: 300,

        sortable: true,
      },
    
    ],
      rows: employeeSalaryList.map((manager,index) => ({
         id: index +1,
         year: manager.year,
         month: manager.month,
         monthvalue : manager.monthvalue
       
       })),
  };

  const handleNewSalaryStructure = () => {
    setexceldisplay(false)
    navigate("/pay-roll/add-payroll");
  };

  const onEmployeeListClick = (e) => {
   
    setexceldisplay(true)
    setexcelmonth(e?.row.monthvalue)
    setexcelyear(e?.row.year)
    if (e?.id) {
      navigate(`/pay-roll/add-payroll?id=${e?.id}`);
    }
  };

  const getMonthName = (monthNumber) => {
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];
    
    return months[monthNumber - 1] || "Invalid month";
};


console.log('nameee',getMonthName(12)); 



  const onSalaryStructureSubmit = async () => {
    const query = `
         query GetAllPayroll {
  allPayroll {
    user{
        id
        firstName
        lastName
      	gender
        fathersName
        maritalStatus
        aadharNumber
        department
        dateOfBirth
        dateOfJoining
      	panNumber
        uanNumber
      
        bankDetails{
        accountNumber
        bankName
        ifscNumber
        branchName
        cifNumber
      }
      }
        updatedCtc
        month
        year
        gross
        totalDeductions
        totalBenefits
        netPay
        netpayWithOtammount
        overallSum
        oneDaySalary
        lossOfPayAmount
}
}
        `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

  
      const EmployeeSalaryResponse = response.data.data.allPayroll;
    
      
      let filterdata = EmployeeSalaryResponse.map((val)=>{
        return{
            year : val.year,
            month : getMonthName(val.month),
            monthvalue : val.month
            
        }
      })
      const uniqueData = filterdata.filter((value, index, self) =>
        index === self.findIndex((obj) => obj.year === value.year && obj.month === value.month)
    );
    
    
     
      setEmployeeSalaryList(uniqueData);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Payroll List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewSalaryStructure()}
              >
                Run Payroll
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          // customHeight={550}
          rows={SalaryStructureListTable.rows}
          // rows={EarningListTable.rows}
          columns={SalaryStructureListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No payroll found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any payroll details. Click on the "Run
                  Payroll" button to start adding payroll.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Payroll;
